
export default function AutomationTable() {
  const automations = [
    {
      task: '商品リサーチ',
      before: 'モールを手動で巡回、Excelに転記',
      after: 'API連携で自動収集・分析',
      effect: '工数80%削減'
    },
    {
      task: '利益計算',
      before: '電卓で毎回計算、ミス多発',
      after: 'スプレッドシートで自動計算',
      effect: 'ミスゼロ化'
    },
    {
      task: '出品データ作成',
      before: 'モールごとに手入力',
      after: 'テンプレートから自動生成',
      effect: '工数90%削減'
    },
    {
      task: '画像リサイズ',
      before: '手動で1枚ずつ加工',
      after: '一括自動リサイズ',
      effect: '工数95%削減'
    },
    {
      task: '在庫同期',
      before: '手動で各モールを更新',
      after: 'リアルタイム自動同期',
      effect: '二重販売ゼロ'
    },
    {
      task: '売上/利益レポート',
      before: 'Excelで手作業集計',
      after: '自動集計・可視化',
      effect: '即座に把握可能'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            自動化できる業務と<strong className="text-primary">効果</strong>
          </h2>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full border-collapse rounded-xl overflow-hidden shadow-lg text-xs md:text-base">
            <thead>
              <tr className="bg-primary text-white">
                <th className="px-3 md:px-6 py-3 md:py-4 text-left font-bold">業務項目</th>
                <th className="px-3 md:px-6 py-3 md:py-4 text-left font-bold">現状の手作業</th>
                <th className="px-3 md:px-6 py-3 md:py-4 text-left font-bold">自動化後</th>
                <th className="px-3 md:px-6 py-3 md:py-4 text-left font-bold">期待できる効果</th>
              </tr>
            </thead>
            <tbody>
              {automations.map((item, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  } hover:bg-primary/5 transition-colors`}
                >
                  <td className="px-3 md:px-6 py-3 md:py-4 font-bold text-gray-900 border-b border-gray-200">
                    {item.task}
                  </td>
                  <td className="px-3 md:px-6 py-3 md:py-4 text-gray-700 border-b border-gray-200">
                    {item.before}
                  </td>
                  <td className="px-3 md:px-6 py-3 md:py-4 text-gray-700 border-b border-gray-200">
                    <div className="flex items-center gap-1 md:gap-2">
                      <i className="ri-check-line text-primary text-base md:text-xl"></i>
                      <span>{item.after}</span>
                    </div>
                  </td>
                  <td className="px-3 md:px-6 py-3 md:py-4 border-b border-gray-200">
                    <strong className="text-primary font-bold">{item.effect}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
